import { createStyles, rem, getStylesRef, keyframes } from '@mantine/core'
export interface StylesParams {
  bgColor: string
  isQuare: boolean
  useImgAsFullBg: boolean
  image?: string
  isImageBg?: boolean
}

export const bgGardient = keyframes({
  '0%': { backgroundPosition: 'top right' },
  '100%': { backgroundPosition: 'top left' },
})

export default createStyles((theme, params: StylesParams) => {
  const { bgColor, isQuare, useImgAsFullBg, image, isImageBg } = params
  return {
    root: {
      position: 'relative',
      display: 'block',
      backgroundColor: bgColor,
      borderRadius: rem(16),
      overflow: 'hidden',
      [theme.fn.smallerThan('sm')]: {
        minHeight: rem(120),
      },
      [theme.fn.largerThan('sm')]: {
        '&:hover': {
          [`.${getStylesRef('info')}`]: {
            transform: 'translateY(10px)',
          },
        },
      },
      ...(useImgAsFullBg && {
        backgroundColor: 'transparent',
      }),
      ...(isImageBg && {
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
      }),
    },
    thumbnail: {
      ref: getStylesRef('thumbnail'),
      position: 'absolute',
      right: rem(40),
      bottom: 0,
      zIndex: 1,
      maxHeight: '100%',
      transition: 'all .2s ease',
      ...(isQuare && {
        maxHeight: '72%',
        right: 0,
        bottom: 0,
      }),
      [theme.fn.smallerThan('sm')]: {
        ...(isQuare && {
          right: 0,
          bottom: 0,
          maxHeight: rem(60),
          height: 'auto',
        }),
      },
      ...(useImgAsFullBg && {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        width: '100%',
        height: '100%',
        maxHeight: 'none !important',
        objectFit: 'cover',
      }),
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      position: 'relative',
      zIndex: 2,
      [theme.fn.largerThan('sm')]: {
        ...(!isQuare && {
          justifyContent: 'space-around',
        }),
      },
      ...(useImgAsFullBg && {
        position: 'relative',
        zIndex: 1,
        [theme.fn.largerThan('sm')]: {
          justifyContent: 'flex-start',
        },
      }),
    },
    info: {
      ref: getStylesRef('info'),
      padding: rem(12),
      display: 'flex',
      flexDirection: 'column',
      gap: isQuare ? rem(2) : rem(8),
      transition: 'all .2s ease',
      [theme.fn.largerThan('sm')]: {
        gap: isQuare ? rem(4) : rem(8),
        padding: rem(24),
      },
    },
    title: {
      color: '#fff',
      ...(isQuare
        ? {
            maxWidth: rem(200),
          }
        : {
            maxWidth: rem(188),
          }),
      [theme.fn.largerThan('sm')]: {
        ...(!isQuare && {
          maxWidth: rem(269),
        }),
      },
    },
    desc: {
      color: '#fff',
      maxWidth: '70%',
    },
    exploreLink: {
      color: '#fff',
      ref: getStylesRef('exploreLink'),
      display: 'flex',
      gap: rem(4),
      [theme.fn.smallerThan('sm')]: {
        alignItems: 'center',
        gap: 0,
      },
    },
    exploreText: {
      color: 'inherit',
    },
    exploreArrow: {
      ref: getStylesRef('exploreArrow'),
      color: '#fff',
      transition: 'transform .3s ease',
      display: 'flex',
      marginTop: rem(1),
      [theme.fn.largerThan('sm')]: {
        marginTop: rem(3),
      },
    },
    hint: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      zIndex: 3,
      paddingBottom: 8,
      paddingLeft: rem(10),
      [theme.fn.largerThan('sm')]: {
        paddingLeft: rem(20),
        paddingBottom: 12,
      },
    },
    popoperDropdown: {
      padding: 0,
      border: 0,
    },
    popoperArrow: {
      backgroundColor: theme.colors.yellow[0],
    },
    disclaimer: {
      padding: rem(8),
      border: `1px solid ${theme.colors.yellow[1]}`,
    },
    disclaimerText: { fontSize: rem(12), lineHeight: rem(18) },
    pattern: {
      position: 'absolute',
      top: rem(-2),
      right: rem(-2),
      left: rem(-2),
      bottom: rem(-2),
      display: 'flex',
      justifyContent: 'flex-end',
      ...(useImgAsFullBg && {
        display: 'none',
      }),
    },
  }
})
